import parseISO from 'date-fns/parseISO'
import isValid from 'date-fns/isValid'

export const switchcase = cases => defaultCase => key =>
  cases.hasOwnProperty(key) ? cases[key] : defaultCase

const parseDate = utcDate => {
  if (!utcDate || utcDate.length === 0) {
    return null
  }
  const getDateFromType = switchcase({
    'string': date => parseISO(date),
    'number': date => new Date(date)
  })(date => date)

  // console.log(getDateFromType(typeof(utcDate))())
  const date =
        typeof(utcDate) === 'string' ? parseISO(utcDate) :
        typeof(utcDate) === 'number' ? new Date(utcDate) :
        typeof(utcDate.getMonth === 'function') ? utcDate :
        utcDate

  return isValid(date) ? date : null
}

export default parseDate



// WEBPACK FOOTER //
// ./src/utility/parseDate.js